import { useState } from 'react';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { useIntl } from 'react-intl';
import { useExerciseExcelImport } from '../../hooks/coach/useExerciseExcelImport';
import ExcelAnalysisDialog from '../dialogs/ExcelAnalysisDialog';
import ImportExercisesHelpDialog from '../dialogs/ImportExercisesHelpDialog';
import ColumnMappingDialog from '../dialogs/ColumnMappingDialog';

interface Props {
  onAfterImport?: () => void;
  setLoading: (v: boolean) => void;
}

export function ExerciseExcelImport({ onAfterImport, setLoading }: Props) {
  const intl = useIntl();
  const imp = useExerciseExcelImport({ onAfterImport, setLoading });
  const [helpVisible, setHelpVisible] = useState(false);

  return (
    <>
      <Button
        label={intl.formatMessage({ id: 'coach.importExercises' })}
        icon="pi pi-upload"
        onClick={() => setHelpVisible(true)}
        className="p-button-outlined"
      />
      <ImportExercisesHelpDialog
        visible={helpVisible}
        onHide={() => setHelpVisible(false)}
        onPickFile={() => imp.fileInputRef.current && imp.fileInputRef.current.click()}
      />
      <input
        ref={imp.fileInputRef}
        type="file"
        accept=".xlsx, .xls, .csv"
        style={{ display: 'none' }}
        onChange={(e) => {
          if (e.target.files && e.target.files.length > 0) {
            const files = { 0: e.target.files[0] as File } as any;
            imp.onTemplateSelect({ files });
            imp.uploadHandler({ files } as any);
          }
        }}
      />
      <FileUpload
        ref={imp.fileUploadRef as any}
        customUpload
        uploadHandler={imp.uploadHandler as any}
        onUpload={imp.onTemplateUpload as any}
        onSelect={imp.onTemplateSelect as any}
        onError={imp.onTemplateError as any}
        onClear={imp.onTemplateClear as any}
        multiple={false}
        maxFileSize={1000000}
        accept=".xlsx, .xls, .csv"
        emptyTemplate={<p className="m-0">{intl.formatMessage({ id: 'coach.dragAndDropExercises' })}</p>}
        style={{ display: 'none' }}
      />

      {imp.mappingDialogVisible && (
        <ColumnMappingDialog
          visible={imp.mappingDialogVisible}
          columns={imp.detectedColumns}
          onConfirm={imp.handleMappingConfirm}
          onHide={imp.handleMappingCancel}
        />
      )}

      {imp.analysisDialogVisible && (
        <ExcelAnalysisDialog
          visible={imp.analysisDialogVisible}
          onHide={imp.handleAnalysisCancel}
          analysisData={imp.analysisData}
          onConfirm={imp.handleAnalysisConfirm}
          setAnalysisData={imp.setAnalysisData}
        />
      )}
    </>
  );
}
